import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=6bf8899c&scoped=true"
import script from "./Cashback.vue?vue&type=script&lang=js"
export * from "./Cashback.vue?vue&type=script&lang=js"
import style0 from "./Cashback.vue?vue&type=style&index=0&id=6bf8899c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8899c",
  null
  
)

export default component.exports